import { TabsTheme as TabsDefaultTheme } from "@acin.reactjs/acin-ui/tabs";
import {
  applyIconColor,
  getMaxWidthMediaQuery,
} from "@acin.reactjs/acin-ui/theme";
import { DefaultTheme } from "styled-components";

const TabsTheme = (theme: DefaultTheme): TabsDefaultTheme => ({
  verticalTabs: {
    topBar: {
      tab: {
        active: {
          root: {
            "&::after": {
              content: "''",
              position: "absolute",
              bottom: 0,
              left: 0,
              width: "100%",
              height: "2px",
              background: theme.palette.primary[700],
            },
          },
          title: {
            color: theme.palette.common.black,
          },
        },
        title: {
          lineHeight: "20px",
          color: "#555555",
        },
      },
      container: {
        paddingLeft: 0,
      },
    },
    title: {
      root: {
        display: "inline-flex",
      },
      content: {
        root: {
          [getMaxWidthMediaQuery(theme.breakpoints.xs)]: {
            maxWidth: "195px",
          },

          [getMaxWidthMediaQuery(360)]: {
            maxWidth: "180px",
          },
        },
        routerTitle: {
          color: theme.palette.common.black,
        },
      },
    },
  },
  topBar: {
    tab: {
      root: {
        lineHeight: "20px",
      },
      active: {
        title: {
          color: "#383838",
          "& button": {
            ...applyIconColor(theme.palette.common.black),
          },

          "&:hover svg path[stroke]:not([stroke='none'])": {
            stroke: theme.palette.common.black,
          },
        },
        closeButton: {
          icon: {
            ...applyIconColor(theme.palette.common.black),
          },

          root: {
            "&:hover svg path[stroke]:not([stroke='none'])": {
              stroke: theme.palette.common.black,
            },
          },
        },
      },
      title: {
        color: "#555555",
      },
    },
    indicator: {
      backgroundColor: "#CDBB27",
    },
  },
});

export default TabsTheme;
